import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const Wrapper = styled.div`
  position: relative;
`;

export const HeaderWrapper = styled.header`
  position: relative;
  z-index: 99;
  width: 100%;
  height: 87px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border-bottom: 1px solid #d2d6da;

  @media (${mediaQuery.tablet}) {
    height: 56px;
  }
`;

export const InnerWrapper = styled.header`
  position: relative;
  z-index: 99;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border-bottom: 1px solid #d2d6da;

  @media (${mediaQuery.tablet}) {
    height: 56px;
  }
`;

export const HeaderRightWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 16px;
  padding: 0 24px 8px 0;

  @media (${mediaQuery.tablet}) {
    margin: 0;
    padding: 0;
  }

  i,
  span {
    font-size: 14px;
    cursor: pointer;
  }
`;

export const DesktopBottomWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 0 32px 0 24px;
  margin-top: 20px;

  .bottom-left {
    flex-grow: 1;
  }

  .bottom-right {
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 16px;
    margin-top: -18px;
    align-items: center;
  }

  @media (${mediaQuery.tablet}) {
    display: none;
  }
`;

export const HeaderCookieWrapper = styled.div`
  display: block;
  padding: 16px 0;
  color: #ffffff;
  background-color: #333f48;
`;

export const HeaderCookieContainer = styled.div`
  width: 100%;
  max-width: 1140px;
  display: flex;
  margin: 0 auto;
  flex-direction: row;
  padding: 0 16px;
`;

export const ImageLock = styled.img`
  width: 16px;
  height: 18px;
  margin-right: 16px;
  margin-top: 4px;
`;

export const ImageClose = styled.img`
  width: 12px;
  height: 12px;
  margin-left: 16px;
  margin-top: 4px;
  cursor: pointer;
`;

export const CookieText = styled.p`
  display: inline;
`;

export const CookieCloseText = styled.span`
  color: #e08a28;
  cursor: pointer;
  font-weight: bold;
`;
